import React from 'react';
import { useTranslation } from 'react-i18next';
import './Interview.css';
import { images, interviewData, titles } from '../../../constants';
import { FaAngleDoubleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Interview = () => {
  const { t } = useTranslation();

  // Bezpieczne pobieranie danych
  const data = interviewData || {};
  const author = data.author || {};
  const calmnestInfo = data.calmnestInfo || {};
  const introParagraphs = Array.isArray(data.intros) ? data.intros : [];
  const sections = Array.isArray(data.sections) ? data.sections : [];
  const partnerContents = Array.isArray(calmnestInfo.contents) ? calmnestInfo.contents : [];
  const bibliography = Array.isArray(data.bibliographys) ? data.bibliographys : [];

  return (
    <div className="interview__wrapper">
      
      {/* --- Sekcja Hero (Banner) --- */}
      <div className='interview__hero'>
        <div className='interview__hero-content'> 
            <h2>{t(titles.interview)}</h2> 
            <h1 className="interview__hero-heading">{t(titles.interview)}</h1>
        </div> 
        
        <div className='interview__breadcrumbs'>
          <Link to='/' className="interview__breadcrumbs-link">{t('interview.breadcrumbs.home', 'Strona Główna')}</Link>
          <FaAngleDoubleRight className='interview__breadcrumbs-icon' />
          <span className='interview__breadcrumbs-current'>{t(titles.interview)}</span>
        </div>
      </div>

      <div className="interview__body">
        <div className="interview__container">
          
          {/* --- SIDEBAR (Lewa kolumna) --- */}
          <aside className="interview__sidebar">
             {/* A) Karta Eksperta */}
             <div className="interview__card interview__card--expert">
                <div className="interview__expert-photo">
                   <img 
                      src={images?.marta_photo} 
                      alt={author.name || 'Ekspert'} 
                   />
                </div>
                <div className="interview__expert-info">
                   <h4>{author.name || 'Ekspert'}</h4>
                   <p className="interview__expert-role">{t(author.role)}</p>
                   <div className="interview__separator"></div>
                   <p className="interview__expert-desc">
                       {t('interview.expert.institute', 'Ekspert Instytutu Psychologii')}<br/>
                       {t('interview.expert.specialization', 'Specjalizacja: Hortiterapia')}
                   </p>
                </div>
             </div>

             {/* B) Karta Partnera */}
             <div className="interview__card interview__card--partner">
                <h4 className="interview__partner-title">
                   {t(calmnestInfo.title)}
                </h4>
                <div className="interview__separator interview__separator--full"></div>
                
                <div className="interview__partner-content">
                   {partnerContents.map((paragraphKey, index) => (
                      <p key={index}>{t(paragraphKey)}</p>
                   ))}
                </div>

                {calmnestInfo.websiteUrl && (
                  <a 
                     href={calmnestInfo.websiteUrl} 
                     target="_blank" 
                     rel="noopener noreferrer"
                     className="interview__partner-btn"
                  >
                     {t('interview.partner.moreAboutUs', 'Więcej o nas na')}<br/> 
                     <span>{calmnestInfo.website}</span>
                  </a>
                )}
             </div>
          </aside>

          {/* --- GŁÓWNA TREŚĆ (Prawa kolumna) --- */}
          <main className="interview__article">
            
            <header className="interview__article-header">
                <h1 className="interview__article-title">{t(data.title)}</h1>
                <h2 className="interview__article-subtitle">{t(data.subtitle)}</h2>
            </header>

            <div className="interview__intro">
                {introParagraphs.map((paragraphKey, index) => (
                   <p key={index} className="interview__text-paragraph">
                       {t(paragraphKey)}
                   </p>
                ))}
            </div>

            <hr className="interview__divider" />

            <div className="interview__content">
                {sections.map((section, index) => (
                   <React.Fragment key={section.id || index}>
                       
                       {/* Tekst Sekcji */}
                       <section className="interview__section">
                           <h3 className="interview__section-heading">
                               {t(section.title)}
                           </h3>
                           <p className="interview__text-paragraph interview__text-paragraph--justify">
                               {t(section.content)}
                           </p>
                       </section>

                       {/* --- LOGIKA WSTAWIANIA ZDJĘĆ --- */}
                       {index === 0 && (
                           <div className="interview__image-wrapper">
                               <img 
                                   src={images?.interview_1} 
                                   alt={t('interview.images.alt1', 'Psychologia w naturze')} 
                                   className="interview__article-image"
                               />
                               <span className="interview__image-caption">
                                   {t('interview.images.caption1', 'Kontakt z naturą wspiera proces terapeutyczny.')}
                               </span>
                           </div>
                       )}

                       {index === 2 && (
                           <div className="interview__image-wrapper">
                               <img 
                                   src={images?.interview_2} 
                                   alt={t('interview.images.alt2', 'Rozmowa terapeutyczna')} 
                                   className="interview__article-image"
                               />
                           </div>
                       )}

                       {index === 4 && (
                           <div className="interview__image-wrapper">
                               <img 
                                   src={images?.interview_3} 
                                   alt={t('interview.images.alt3', 'Spokój i równowaga')} 
                                   className="interview__article-image"
                               />
                           </div>
                       )}

                   </React.Fragment>
                ))}
            </div>

            {bibliography.length > 0 && (
              <footer className="interview__footer">
                  <div className="interview__bibliography">
                      <h4>{t('interview.bibliography.title', 'Bibliografia')}</h4>
                      <ul>
                          {bibliography.map((itemKey, index) => (
                              <li key={index}>{t(itemKey)}</li>
                          ))}
                      </ul>
                  </div>
              </footer>
            )}

          </main>

        </div>
      </div>
    </div>
  );
}

export default Interview;